export const AnalyticsEvent = Object.freeze({
  POST_VIEW: "post_view",
});
